import { render, staticRenderFns } from "./english-answer.vue?vue&type=template&id=ed19229c&scoped=true&"
import script from "../../assets/js/exam/english-answer.js?vue&type=script&lang=js&"
export * from "../../assets/js/exam/english-answer.js?vue&type=script&lang=js&"
import style0 from "../../assets/css/exam.css?vue&type=style&index=0&id=ed19229c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed19229c",
  null
  
)

export default component.exports